export const VERSIONS = {
  DEFAULT: 'default',
  HCP: 'hcp',
  QUESTIONNAIRE: 'questionnaire',
  PATIENT_MAIN: 'patient_main',
  CUSTOM: 'custom',
};

export const TAB_IDS = {
  FEED: 'feed',
  TREATMENT_OPTIONS: 'treatment_options',
  SUPPORT_PROGRAMS: 'support_programs',
  SPEAK_WITH_TINA: 'speak_with_tina',
  SYMPTOM_CARE: 'symptom_care',
  ARTICLES: 'articles',
  HCP_TREATMENT_OPTIONS: 'hcp_treatment_options',
  HCP_SUPPORT_PROGRAMS: 'hcp_support_programs',
};

export const HEADER_THEME = {
  DEFAULT: 'default',
  WHITE: 'white',
};
